// Runtime-дефолты backend-контракта. Отдельно от types.ts — там по его шапке
// живут только типы, а это значение существует в рантайме.
import type { TaskPriority } from './types';

// PARA-128 — обязан совпадать с доменной константой DEFAULT_TASK_PRIORITY
// (backend/app/domain/entities.py) и с server_default колонки tasks.priority.
export const DEFAULT_TASK_PRIORITY: TaskPriority = 'MEDIUM';
